import { ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';
import { connect, MapDispatchToProps } from 'react-redux';
import { RouteComponentProps } from '@reach/router';
import { logoutUser } from 'store/thisUser/thisUserSlice';

type DispatchProps = {
  logOutUser: () => void;
};

type OwnProps = RouteComponentProps;

type ComponentProps = DispatchProps & OwnProps;

class Logout extends React.PureComponent<ComponentProps> {
  componentDidMount() {
    this.props.logOutUser();
  }

  render() {
    return null;
  }
}

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch: ThunkDispatch<any, never, any>
) => ({
  logOutUser: () => dispatch(logoutUser({ shouldRedirect: true })),
});

export default connect(undefined, mapDispatchToProps)(Logout);
